<template>
  <div class="header">
    <div class="header-inner">
      <div class="WUS-logo" v-if="logoType == 0">
        <router-link to="/" class="menu-list">
          <img src="@/assets/company-logo.png" />
        </router-link>
      </div>
      <div class="OSL-logo" v-else>
        ON STYLE
        <span>LIVE</span>
      </div>
      <div class="OSL-menu">
        <router-link to="/company" class="menu-list">COMPANY</router-link>
        <router-link to="/product" class="menu-list">PRODUCT</router-link>
        <!-- <router-link to="/joinus" class="menu-list">JOIN US</router-link> -->
        <router-link to="/contactus" class="menu-list">CONTACT US</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PcHeader",
  data() {
    return {
      logoType: 0
    };
  },
  watch: {
    // 라우트가 변경되면 메소드를 다시 호출됩니다.
    $route: "fetchData"
  },
  methods: {
    fetchData(data) {
      console.log("fetchData", data);
      if (data.name == "PRODUCT" || data.name == "JOINUS") {
        this.logoType = 1;
      } else {
        this.logoType = 0;
      }
    },
    didClickIndex(idx) {
      this.selectIndex = idx;
    }
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.name == "PRODUCT" || this.$route.name == "JOINUS") {
      this.logoType = 1;
    } else {
      this.logoType = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  border-bottom: rgba(0, 0, 0, 0.2) 1px solid;
  position: fixed;
  z-index: 100;

  .header-inner {
    width: 1100px;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .OSL-logo {
      font-size: 1.8em;
      font-weight: 900;

      span {
        color: #97b9b2;
      }
    }

    .WUS-logo {
      height: 100%;
      position: relative;

      img {
        height: 80%;
        padding: 8px 0px 8px 0px;
      }
    }

    .OSL-menu {
      display: flex;
      flex-direction: row;

      .menu-list {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.4);
        padding: 5px 0px 5px 40px;
        text-decoration: none;

        &:hover {
          cursor: pointer;
          color: #272727;
          font-weight: 600;
        }

        &.selected {
          color: #272727;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.OSL-menu {
  .menu-list {
    &.router-link-active {
      color: #272727 !important;
    }
  }
}
</style>